import { AppStateType } from "../utils/utils";

export const getWidgetId = (galleryEmbedId: number, shop: string, photoRequestId: number, el: HTMLElement) => {
  const widgetParams = {
    embedId: null,
    productHandle: null,
    shopDomain: null,
    photoRequestId: null
  };

  const uri = window.location;

  widgetParams.embedId = galleryEmbedId;
  widgetParams.photoRequestId = photoRequestId;

  if (el.hasAttribute("data-product")) {
    widgetParams.productHandle = el.getAttribute("data-product");
  } else if (uri.pathname.indexOf("/products/") !== -1) {
    widgetParams.productHandle = uri.pathname.match(/\/products\/([a-zA-Z0-9\-\_\%]+)/)[1];
  }

  if (shop !== "") {
    widgetParams.shopDomain = shop;
  } else if (el.hasAttribute("data-shop")) {
    widgetParams.shopDomain = el.getAttribute("data-shop");
  } else {
    widgetParams.shopDomain = uri.hostname;
  }

  return { ...widgetParams };
};

export const sendBeacon = (state: AppStateType, event: string, data: object = {}) => {
  const isUseAnalytics = state.preview.mode ? false : state.analytics;
  if (!isUseAnalytics) return false;

  const url = `${state.url.baseBeaconsUrl}${event}`;

  const payload = {
    gallery_id: state.widgetId.galleryId,
    shop_id: state.widgetId.shopId,
    ...data
  };

  navigator.sendBeacon(url, JSON.stringify(payload));
};
